import { render, staticRenderFns } from "./twitter_instantwin_message_history.vue?vue&type=template&id=2dda3b4c"
import script from "./twitter_instantwin_message_history.vue?vue&type=script&lang=ts"
export * from "./twitter_instantwin_message_history.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports